import React from 'react';
interface LogoProps {
  onClick?: () => void;
  /** chip size variant */
  size?: 'sm' | 'md';
  /** show the full ALEX CIRCEI wordmark next to the chip */
  showWordmark?: boolean;
  className?: string;
}
/**
 * Distinctive brand mark for Alex Circei.
 * A terminal-style "[AC]" chip paired with a monospace wordmark and a
 * blinking cursor — signals an engineering-analytics operator, not a
 * generic consultant template.
 */
export function Logo({
  onClick,
  size = 'md',
  showWordmark = true,
  className = ''
}: LogoProps) {
  return <button onClick={onClick} aria-label="Alex Circei — home" className={`group inline-flex items-center gap-3 select-none ${className}`} data-id="element-200">
      {/* leading accent bracket */}
      <span className="font-mono text-accent text-lg leading-none transition-transform duration-300 group-hover:-translate-x-0.5" data-id="element-201">
        [
      </span>

      {/* wordmark */}
      <span className="flex items-baseline font-mono font-medium tracking-[0.18em] text-primary text-sm uppercase" data-id="element-202">
        Alex
        <span className="text-muted mx-1" data-id="element-203">·</span>
        Circei
        <span className="ml-1 inline-block w-[7px] h-[15px] bg-accent translate-y-0.5 animate-blink" data-id="element-204" />
      </span>

      {/* trailing accent bracket */}
      <span className="font-mono text-accent text-lg leading-none transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-205">
        ]
      </span>
    </button>;
}